/** Sovos -1 means not processed and 10-29 are auth/config errors: the check has no result. */
export function isTinCheckUnprocessed(code: number | null | undefined): boolean {
    return code == null || Number.isNaN(code) || code < 0 || code >= 10;
}

/** Sovos TinNameCode values meaning the TIN and name matched IRS records. */
const TIN_NAME_MATCH_CODES = [1, 6, 7, 8];

export function isTinNameMatch(tinNameCode: number | null | undefined): boolean {
    return tinNameCode != null && TIN_NAME_MATCH_CODES.includes(tinNameCode);
}

/** Sovos ListsMatchCode 0 is no match; -1 and 10+ mean the lists were not checked. */
export function isWatchlistMatch(listsMatchCode: number | null | undefined): boolean {
    return listsMatchCode != null && listsMatchCode > 0 && listsMatchCode < 10;
}
